
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/documentation",
      function () {
        return require("private-next-pages/resources/documentation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/documentation"])
      });
    }
  